import { removeTenderDocumentFiles } from '../../services/tenderDocumentFiles';
import { deleteTenderDocument } from '../../services/tenderDocuments';
import { confirmDelete, notify } from '../../store/feedback';
import { updateNoticeDocuments } from './uploadState';

export default function tenderDeleteDocumentHandlers(deps) {
  const { setTenderUploadBusy } = deps;

  // Supprime un document importé à tort (ex : extraction ratée avant le correctif du worker pdfjs) —
  // ne relance pas l'analyse automatiquement, celle-ci ne se redéclenche qu'à un nouvel import.
  async function removeTenderDocument(idweb, doc) {
    if (!(await confirmDelete(`Supprimer ${doc.filename} ?`))) return;
    setTenderUploadBusy(true);
    try {
      const { error: storageErr } = await removeTenderDocumentFiles(doc);
      if (storageErr) return void notify('Erreur suppression fichier : ' + storageErr.message);
      const { error: dbErr } = await deleteTenderDocument(doc);
      if (dbErr) return void notify('Erreur suppression : ' + dbErr.message);
      updateNoticeDocuments(deps, idweb, (docs) => docs.filter((d) => d.id !== doc.id));
    } finally {
      setTenderUploadBusy(false);
    }
  }

  return { removeTenderDocument };
}
